module.exports = __webpack_public_path__ + "fonts/EMprint-Semibold.eacfb9f2.ttf";